(() => {
  if (window.palkaProductLoaded) return;
  window.palkaProductLoaded = true;
  const initialize = (root) => {
    if (!root || root.dataset.palkaProductReady === "true") return;
    root.dataset.palkaProductReady = "true";

    const mediaList = root.querySelector(".palka-product-gallery__list");
    const thumbnails = [...root.querySelectorAll("[data-palka-media-target]")];
    const showMedia = (targetId, behavior = "smooth") => {
      const target = document.getElementById(targetId);
      if (!mediaList || !target) return;
      mediaList.scrollTo({
        left: target.offsetLeft - mediaList.offsetLeft,
        behavior,
      });
      thumbnails.forEach((thumbnail) => {
        const active = thumbnail.dataset.palkaMediaTarget === targetId;
        thumbnail.classList.toggle("is-active", active);
        thumbnail.setAttribute("aria-current", String(active));
      });
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", () =>
        showMedia(thumbnail.dataset.palkaMediaTarget),
      );
    });

    if (mediaList && thumbnails.length > 1) {
      let mediaScrollFrame;
      mediaList.addEventListener(
        "scroll",
        () => {
          window.cancelAnimationFrame(mediaScrollFrame);
          mediaScrollFrame = window.requestAnimationFrame(() => {
            const media = [...mediaList.children].reduce((nearest, item) =>
              Math.abs(
                item.offsetLeft - mediaList.offsetLeft - mediaList.scrollLeft,
              ) <
              Math.abs(
                nearest.offsetLeft -
                  mediaList.offsetLeft -
                  mediaList.scrollLeft,
              )
                ? item
                : nearest,
            );
            if (!media) return;
            thumbnails.forEach((thumbnail) => {
              const active = thumbnail.dataset.palkaMediaTarget === media.id;
              thumbnail.classList.toggle("is-active", active);
              thumbnail.setAttribute("aria-current", String(active));
            });
          });
        },
        { passive: true },
      );
    }

    if (mediaList) {
      const slides = [...mediaList.children];
      mediaList.tabIndex = 0;
      mediaList.setAttribute(
        "aria-label",
        "商品写真。左右の矢印キーでも切り替えられます",
      );
      if (slides.length > 1) {
        const controls = document.createElement("div");
        controls.className = "palka-gallery-controls";
        const previous = document.createElement("button");
        previous.type = "button";
        previous.textContent = "‹";
        previous.setAttribute("aria-label", "前の商品写真");
        const next = document.createElement("button");
        next.type = "button";
        next.textContent = "›";
        next.setAttribute("aria-label", "次の商品写真");
        const counter = document.createElement("span");
        counter.setAttribute("aria-live", "polite");
        counter.setAttribute("aria-atomic", "true");
        controls.append(previous, counter, next);
        mediaList.after(controls);
        const indexNow = () =>
          slides.reduce(
            (best, slide, i) =>
              Math.abs(
                slide.offsetLeft - slides[0].offsetLeft - mediaList.scrollLeft,
              ) <
              Math.abs(
                slides[best].offsetLeft -
                  slides[0].offsetLeft -
                  mediaList.scrollLeft,
              )
                ? i
                : best,
            0,
          );
        const updateGallery = () => {
          const i = indexNow();
          counter.textContent = i + 1 + " / " + slides.length;
          previous.disabled = i === 0;
          next.disabled = i === slides.length - 1;
        };
        const moveGallery = (direction) => {
          const i = Math.max(
            0,
            Math.min(slides.length - 1, indexNow() + direction),
          );
          mediaList.scrollTo({
            left: slides[i].offsetLeft - slides[0].offsetLeft,
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
              .matches
              ? "auto"
              : "smooth",
          });
        };
        previous.addEventListener("click", () => moveGallery(-1));
        next.addEventListener("click", () => moveGallery(1));
        mediaList.addEventListener("keydown", (event) => {
          if (event.target !== mediaList) return;
          if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
            event.preventDefault();
            moveGallery(event.key === "ArrowRight" ? 1 : -1);
          }
        });
        let galleryFrame;
        mediaList.addEventListener(
          "scroll",
          () => {
            cancelAnimationFrame(galleryFrame);
            galleryFrame = requestAnimationFrame(updateGallery);
          },
          { passive: true },
        );
        if (window.ResizeObserver)
          new ResizeObserver(updateGallery).observe(mediaList);
        updateGallery();
      }
    }

    // View the original product photo without changing the gallery or purchase form.
    const zoomPhotos = [...root.querySelectorAll('.palka-product-gallery__media--image img')];
    if (zoomPhotos.length && typeof HTMLDialogElement !== 'undefined') {
      const dialog = document.createElement('dialog');
      dialog.className = 'palka-photo-viewer';
      dialog.setAttribute('aria-label', '商品写真を拡大表示');
      dialog.tabIndex = -1;
      dialog.setAttribute('aria-description', '写真の外側を押すか、Escキーで閉じます。');
      const photo = document.createElement('img');
      photo.className = 'palka-photo-viewer__image';
      dialog.append(photo);
      root.append(dialog);
      let trigger, previousOverflow;
      const openPhoto = (image) => {
        if (dialog.open) return;
        trigger = image;
        const source = new URL(image.currentSrc || image.src, location.href);
        source.searchParams.set('width', '2400');
        photo.src = source.href;
        photo.alt = image.alt || '商品写真';
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        dialog.focus({ preventScroll: true });
      };
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        trigger?.focus({ preventScroll: true });
      });
      zoomPhotos.forEach((image) => {
        image.tabIndex = 0;
        image.setAttribute('role', 'button');
        image.setAttribute('aria-label', (image.alt || '商品写真') + 'を拡大');
        image.setAttribute('aria-haspopup', 'dialog');
        image.title = 'クリックして拡大';
        image.draggable = false;
        let startX = 0, startY = 0, startScroll = 0, cancelled = false;
        image.addEventListener('pointerdown', (event) => {
          startX = event.clientX;
          startY = event.clientY;
          startScroll = mediaList?.scrollLeft || 0;
          cancelled = false;
        });
        image.addEventListener('pointercancel', () => { cancelled = true; });
        image.addEventListener('click', (event) => {
          if (event.detail && (cancelled || Math.abs(event.clientX - startX) > 10 ||
            Math.abs(event.clientY - startY) > 10 || Math.abs((mediaList?.scrollLeft || 0) - startScroll) > 10)) return;
          openPhoto(image);
        });
        image.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openPhoto(image);
          }
        });
      });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root) && dialog.open) dialog.close();
      });
    }

    const select = root.querySelector("[data-palka-variant-select]");
    const price = root.querySelector("[data-palka-product-price]");
    const compare = root.querySelector("[data-palka-product-compare]");
    const unitPrice = root.querySelector("[data-palka-product-unit-price]");
    const stock = root.querySelector("[data-palka-product-stock]");
    const submit = root.querySelector("[data-palka-product-submit]");
    const submitLabel = root.querySelector("[data-palka-product-submit-label]");
    const quantity = root.querySelector('[name="quantity"]');
    const quantityMinus = root.querySelector("[data-palka-quantity-minus]");
    const quantityPlus = root.querySelector("[data-palka-quantity-plus]");
    const dynamicCheckout = root.querySelector("[data-palka-dynamic-checkout]");

    const updateQuantityButtons = () => {
      if (!quantity) return;
      const value = Number(quantity.value);
      const minimum = Number(quantity.min || 1);
      const maximum = quantity.max
        ? Number(quantity.max)
        : Number.POSITIVE_INFINITY;
      const unavailable = Boolean(submit?.disabled);
      if (quantityMinus)
        quantityMinus.disabled = unavailable || value <= minimum;
      if (quantityPlus) quantityPlus.disabled = unavailable || value >= maximum;
    };

    const changeQuantity = (direction) => {
      if (!quantity) return;
      try {
        if (direction < 0) quantity.stepDown();
        else quantity.stepUp();
      } catch (_error) {
        quantity.value = quantity.min || "1";
      }
      quantity.dispatchEvent(new Event("change", { bubbles: true }));
      updateQuantityButtons();
    };

    quantityMinus?.addEventListener("click", () => changeQuantity(-1));
    quantityPlus?.addEventListener("click", () => changeQuantity(1));
    quantity?.addEventListener("input", updateQuantityButtons);
    quantity?.addEventListener("change", updateQuantityButtons);

    const updateVariantState = () => {
      if (!select) {
        updateQuantityButtons();
        return;
      }
      const option = select.options[select.selectedIndex];
      if (!option) return;

      const available = option.dataset.available === "true";
      if (price) price.textContent = option.dataset.price || "";

      if (compare) {
        compare.textContent = option.dataset.comparePrice || "";
        compare.hidden = !option.dataset.comparePrice;
      }

      if (unitPrice) {
        unitPrice.textContent = option.dataset.unitPrice || "";
        unitPrice.hidden = !option.dataset.unitPrice;
      }

      if (stock) stock.textContent = option.dataset.stockLabel || "";

      if (submit) {
        submit.disabled = !available;
        submit.setAttribute("aria-disabled", String(!available));
      }
      if (submitLabel)
        submitLabel.textContent = available ? "購入へ進む" : "SOLD OUT";
      if (dynamicCheckout) dynamicCheckout.hidden = !available;

      if (quantity) {
        quantity.min = option.dataset.quantityMin || "1";
        quantity.step = option.dataset.quantityStep || "1";
        if (option.dataset.quantityMax)
          quantity.max = option.dataset.quantityMax;
        else quantity.removeAttribute("max");
        if (Number(quantity.value) < Number(quantity.min))
          quantity.value = quantity.min;
        if (quantity.max && Number(quantity.value) > Number(quantity.max))
          quantity.value = quantity.max;
      }

      if (option.dataset.mediaId) {
        showMedia(`${root.dataset.palkaMediaPrefix}${option.dataset.mediaId}`);
      }
      updateQuantityButtons();
    };

    select?.addEventListener("change", updateVariantState);
    updateVariantState();
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.("[data-palka-product-main]")) initialize(scope);
    scope.querySelectorAll?.("[data-palka-product-main]").forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll(), {
      once: true,
    });
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", (event) =>
    initializeAll(event.target),
  );
})();
